import React, { useEffect, useState } from "react";
import _ from "lodash";
import ContentWrapper from "../../Wrapper";
import { CustomSubHeader } from "../../../components/subheader";
import { BlueGradientButton } from "../../../components/button";
import { useDispatch, useSelector } from "react-redux";
import { Spinner } from "react-bootstrap";
import { CustomEmptyPage } from "../../../components/empty_page/custom-empty-page";
import * as emailValidationActions from "../store/actions/email-validation.actions";
import CustomSidePanel from "../../../components/side-pannel-detailed/custom-components/custom-side-pannel";
import { CustomTableWithoutAction } from "../../../components/custom-tables/table-without-actions";
import { NormalTable } from "../../../components/table/normalTable";
import { useHistory } from "react-router-dom";

const campaingTableFields = ["Plan Type", "Currency", "Per Email Price", "Status"];
const campaignTableMapping = {
    "Plan Type": "planType",
    Currency: "currency",
    "Per Email Price": "price",
    Status: "status",
};

export const campaignTableFieldDataType = {
    planType: "TEXT",
    currency: "LIGHT_TAG",
    emailPrice: "TEXT",
    status: "TAG",
};
export default function EmailValidationPage() {
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [showPricing, setShowPricing] = useState(false);

    const dispatch = useDispatch();
    const history = useHistory();

    const emailValidationStore = useSelector(store => store.integrationApps.emailValidation.data);
    const emailValidationPricingStore = useSelector(store => store.integrationApps.emailValidation.pricing);

    useEffect(() => {
        const payload = { page: page, limit: limit };
        dispatch(emailValidationActions.getListOfEmailValidationRequest(payload))
    }, [dispatch, page, limit])
    useEffect(() => {
        dispatch(emailValidationActions.getEmailValidationPricingRequest("email_validation"))
    }, [dispatch])

    const onPricingClick = () => {
        setShowPricing(true);
    }


    const columns = [
        { apiKeyName: "createdAt", fieldInputType: "DATE_TIME", fieldName: "Date" },
        { apiKeyName: "mode", fieldInputType: "INPUT", fieldName: "Module Name" },
        { apiKeyName: "type", fieldInputType: "INPUT", fieldName: "Request Type" },
        { apiKeyName: "count", fieldInputType: "INPUT", fieldName: "Total" },
        { apiKeyName: "valid", fieldInputType: "INPUT", fieldName: "Valid" },
        { apiKeyName: "invalid", fieldInputType: "INPUT", fieldName: "Invalid" },
        { apiKeyName: "percentage", fieldInputType: "INPUT", fieldName: "Percentage" },
        { apiKeyName: "owner", fieldInputType: "OWNER_SELECT", fieldName: "Owner" },
        { apiKeyName: "errorMessage", fieldInputType: "INPUT", fieldName: "Comment" },
        { apiKeyName: "status", fieldInputType: "STATUS_DISPLAY", fieldName: "Status" },
    ];

    const tableProps = {
        columns: columns,
        data: emailValidationStore.list.map((each) => {
            each.percentage = `${_.parseInt(each.percentage)}%`;
            return each;
        }),
        pagination: true,
        count: emailValidationStore.count,
        limit: limit,
        pageNo: page,
        setLimit: setLimit,
        setPageNo: setPage,
        setChecked: () => { },
        loading: emailValidationStore.loading,
    };

    return <ContentWrapper
        subHeader={
            <CustomSubHeader>
                <div className="d-flex w-100 flex-stack">
                    <div onClick={() => history.push("/settings/integrations")} className="d-flex align-items-center cursor-pointer" >
                        <i className="bi bi-arrow-left" style={{ color: "#333" }}></i>
                        <span className="ml-2"> Back to integrations</span>
                    </div>
                    <BlueGradientButton variant="success" size="sm" onClick={() => onPricingClick()}>
                        Pricing
                    </BlueGradientButton>
                </div>
            </CustomSubHeader>
        }
    >
        {emailValidationStore.loading ? (
            <div className="card w-100 d-flex justify-content-center align-items-center h-vh-162px">
                <Spinner animation="border" variant="primary" />
            </div>
        ) : emailValidationStore.list.length === 0 ? (
            <CustomEmptyPage page="emailValidation" />
        ) : (
            <div className={`card card-custom`}>
                <div className="card-body py-3 px-3">
                    <NormalTable props={tableProps} />
                </div>
            </div>
        )}
        <CustomSidePanel
            show={showPricing}
            moduleName={"Email Validation Pricing"}
            handleClose={() => setShowPricing(false)}
            showNextButton={false}
            showPreviosButton={false}
            customStyles={{
                width: "50vw",
                right: "51vw",
            }}
        >
            <div className="pricing-container">
                <div className="pricing-header d-flex flex-stack align-items-center">
                    <h3 className="fw-bolder text-dark">Email Validation Pricing</h3>
                </div>
                <div className="pricing-content-container p-8">
                    <div>
                        <div className="card">
                            <CustomTableWithoutAction
                                tablehead={campaingTableFields}
                                tablecontent={emailValidationPricingStore.data.map((each) => {
                                    each.planType = "Regular";
                                    each.currency = _.upperCase(each.currency);
                                    return each;
                                })}
                                mappingTable={campaignTableMapping}
                                dataType={campaignTableFieldDataType}
                                pageNo={1}
                                limit={limit}
                                count={1}
                                setPageNo={() => { }}
                                setLimit={() => { }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </CustomSidePanel>
    </ContentWrapper>
}